import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { EntityState, serializeAxiosError, IQueryParams } from 'app/shared/reducers/reducer.utils';
import { IIndicatorDto, defaultValue } from 'app/shared/model/indicator-dto.model';
import { IKpiTiresDto, IKpiTiresResponse } from 'app/shared/model/indicator-dto';

const initialState: EntityState<IIndicatorDto> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};
export interface IIndicatorTiresProps extends IQueryParams {
  currentStatus?: string | null;
  companyId?: number | null;
}

const apiUrl = '/api/indicator-tires';

// Actions

export const getIndicatorTiresCondition = createAsyncThunk(
  'indicatorTires/fetch_indicator_tires_condition',
  async ({ companyId, currentStatus }: IIndicatorTiresProps) => {
    const apiUrlComplete = `${apiUrl}/condition/${currentStatus}${companyId ? `?searchCompanyId=${companyId}` : ''}`;
    const response = await axios.get<IKpiTiresDto[]>(apiUrlComplete);
    return response.data;
  },
  { serializeError: serializeAxiosError }
);

export const getIndicatorTiresConditionHistory = createAsyncThunk(
  'indicatorTires/fetch_indicator_tires_condition_history',
  async ({ companyId, currentStatus }: IIndicatorTiresProps) => {
    const apiUrlComplete = `${apiUrl}/condition-history/${currentStatus}${companyId ? `?searchCompanyId=${companyId}` : ''}`;
    const response = await axios.get<IKpiTiresDto[]>(apiUrlComplete);
    return response.data;
  },
  { serializeError: serializeAxiosError }
);

export const getIndicatorTires = createAsyncThunk(
  'indicatorTires/fetch_indicator_tires',
  async ({ companyId }: IIndicatorTiresProps) => {
    const apiUrlComplete = `${apiUrl}${companyId ? `?searchCompanyId=${companyId}` : ''}`;
    const response = await axios.get<IKpiTiresResponse>(apiUrlComplete);
    return response.data;
  },
  { serializeError: serializeAxiosError }
);

// Slice

const indicatorTiresSlice = createSlice({
  name: 'indicatorTires',
  initialState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getIndicatorTiresCondition.fulfilled, (state, action) => {
        state.loading = false;
        state.entity.kpiTires = action.payload;
      })
      .addCase(getIndicatorTiresCondition.pending, state => {
        state.loading = true;
      })
      .addCase(getIndicatorTiresCondition.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message || 'Error fetching data';
      })
      .addCase(getIndicatorTiresConditionHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.entity.kpiTiresHistory = action.payload;
      })
      .addCase(getIndicatorTiresConditionHistory.pending, state => {
        state.loading = true;
      })
      .addCase(getIndicatorTiresConditionHistory.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message || 'Error fetching data';
      })
      .addCase(getIndicatorTires.fulfilled, (state, action) => {
        state.loading = false;
        state.entity.kpiTiresResponse = action.payload;
      })
      .addCase(getIndicatorTires.pending, state => {
        state.loading = true;
      })
      .addCase(getIndicatorTires.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message || 'Error fetching data';
      });
  },
});

export const { reset } = indicatorTiresSlice.actions;

export default indicatorTiresSlice.reducer;
